import BaseLayer from "./BaseLayer";
import {plotTileMotionHelper} from "../utils/map_utils";

class StitchRound3TileMotionv2 extends BaseLayer {

    id = "stitchRound3TileMotionv2";
    label = "Tiles Moved";
    defaultVisible = this.props.tileViewerState[this.id];

    draw = () => new Promise((resolve, reject) => {
        let {stitchR3TileMotion, textColor} = this.props;
        plotTileMotionHelper(stitchR3TileMotion, this.props.slide, this.layer.getSource(), textColor);
        resolve();
    });
}

export default StitchRound3TileMotionv2;
